import { render, staticRenderFns } from "./BatchLoanTermination.vue?vue&type=template&id=79761601&"
import script from "./BatchLoanTermination.vue?vue&type=script&lang=js&"
export * from "./BatchLoanTermination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports